import { render, staticRenderFns } from "./LiveButton.vue?vue&type=template&id=1e391d3e&scoped=true&"
import script from "./LiveButton.vue?vue&type=script&lang=ts&"
export * from "./LiveButton.vue?vue&type=script&lang=ts&"
import style0 from "./LiveButton.vue?vue&type=style&index=0&id=1e391d3e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e391d3e",
  null
  
)

export default component.exports